<template>
  <v-container>
    <v-card
      class="mb-3"
      v-if="
        currentUser.role === 'ADMINISTRADOR' ||
          (currentUser.role === 'COMISSAO_DOCUMENTACAO' &&
            preMatricula.status.codigo === 'APROVADA')
      "
    >
      <v-toolbar
        :color="getCorStatusMatricula.class"
        :dark="getCorStatusMatricula.dark"
        flat
      >
        <v-toolbar-title style="color: white;"
          >Efetivação do Registro de Matrícula no Sistema
          Acadêmico</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn
          class="mx-2"
          fab
          dark
          color="green"
          v-if="
            (preMatricula.statusRegistroMatricula.codigo ==
              'CANDIDATO_NAO_REGISTRADO' &&
              this.currentUser.role == 'COMISSAO_DOCUMENTACAO') ||
              this.currentUser.role == 'ADMINISTRADOR'
          "
          @click="alterarStatusRegistroMatricula"
        >
          <v-icon dark> mdi-pencil </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-list dense>
          <v-list-item
            >Status Atual:
            {{ preMatricula.statusRegistroMatricula.descricao }}</v-list-item
          >
        </v-list>
      </v-card-text>
      <v-dialog
        v-model="dlgAlterarStatusMatricula"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title
            >Efetivação do Registro de Matrícula no Sistema
            Acadêmico</v-card-title
          >
          <v-card-text>
            <v-radio-group
              v-model="preMatricula.statusRegistroMatricula.codigo"
            >
              <v-radio
                v-for="tipo in tipoStatusPreMatricula"
                :key="tipo.codigo"
                class="mb-3"
                :label="tipo.descricao"
                :value="tipo.codigo"
              >
              </v-radio>
            </v-radio-group>
          </v-card-text>
          <v-card-actions>
            <v-container>
              <v-row>
                <v-col xs="12">
                  <v-btn
                    block
                    color="warning"
                    @click="fecharAlterarStatusRegistroMatricula"
                  >
                    Fechar
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn
                    block
                    color="primary"
                    @click="salvarStatusRegistroPreMatricula()"
                  >
                    Salvar
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>

    <v-card class="mb-3">
      <v-toolbar color="secondary" dark flat>
        <v-toolbar-title
          >Dados do candidato:
          {{ preMatricula.candidato.dadosPessoais.nome }}
        </v-toolbar-title>
      </v-toolbar>
      <dados-basicos-candidato
        :candidato="preMatricula.candidato"
      ></dados-basicos-candidato>
    </v-card>
    <v-card class="mb-3">
      <v-card
        v-for="analise in preMatricula.analises"
        :key="analise.id"
        class="mb-3"
      >
        <v-toolbar :color="analise.status.cor || 'orange'" dark flat>
          <v-toolbar-title
            >{{ analise.descricao === "Renda" ? "Comprovação" : "Análise" }}:
            {{ analise.descricao }}

            <template v-if="analise.descricao === 'Renda'">
              - Salário Mínimo Referencial:
              {{ formatarReal(preMatricula.valorRefSalario) }}
            </template>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            class="mx-2"
            fab
            dark
            color="green"
            v-if="podeEmitirParecer(analise)"
            @click="emitirParecer(analise)"
          >
            <v-icon dark> mdi-pencil </v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <div
            v-if="
              analise.status.codigo != 'AGUARDA_RECURSO' &&
                analise.status.codigo != 'PRAZO_EXPIRADO'
            "
          >
            Status: {{ analise.status.descricao }}
          </div>
          <div v-else>
            <div
              v-if="analise.parecer.dataLimiteParaRecursoExpirada"
              class="error"
            >
              <span class="white--text">
                Prazo para recurso expirado:
                {{ analise.parecer.dataLimiteParaRecurso }}</span
              >
            </div>
            <div v-else class="secondary">
              <span class="white--text">
                Prazo para recurso:
                {{ analise.parecer.dataLimiteParaRecurso }}</span
              >
            </div>
          </div>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left"></th>
                  <th class="text-left">Descrição</th>
                  <th class="text-left">Tipo</th>
                  <th width="50px" class="text-left">Ações</th>
                  <th width="50px" class="text-left">ADM</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="analise.parecer">
                  <td>Parecer Inicial</td>
                  <td>{{ analise.parecer.texto | truncate(70, "...") }}</td>
                  <td>{{ analise.parecer.situacao.descricao }}</td>
                  <td>
                    <v-icon small @click="visualizarItem(analise.parecer)">
                      mdi-eye
                    </v-icon>
                    <br />
                  </td>
                  <td
                    v-if="
                      !analise.recurso && currentUser.role == 'ADMINISTRADOR'
                    "
                  >
                    <v-icon
                      small
                      color="error"
                      @click="excluirUltimoItem(analise.id)"
                    >
                      mdi-delete
                    </v-icon>
                  </td>
                </tr>
                <tr v-if="analise.recurso">
                  <td>Recurso</td>
                  <td>{{ analise.recurso.texto | truncate(70, "...") }}</td>
                  <td>{{ analise.recurso.status.descricao }}</td>
                  <td>
                    <v-icon small @click="visualizarItem(analise.recurso)">
                      mdi-eye
                    </v-icon>
                  </td>
                  <td
                    v-if="
                      !analise.parecerDoRecurso &&
                        currentUser.role == 'ADMINISTRADOR'
                    "
                  >
                    <v-icon
                      small
                      color="error"
                      @click="excluirUltimoItem(analise.id)"
                    >
                      mdi-delete
                    </v-icon>
                  </td>
                </tr>
                <tr v-if="analise.parecerDoRecurso">
                  <td>Parecer do Recurso</td>
                  <td>
                    {{ analise.parecerDoRecurso.texto | truncate(70, "...") }}
                  </td>
                  <td>{{ analise.parecerDoRecurso.situacao.descricao }}</td>
                  <td>
                    <v-icon
                      small
                      @click="visualizarItem(analise.parecerDoRecurso)"
                    >
                      mdi-eye
                    </v-icon>
                  </td>
                  <td v-if="currentUser.role == 'ADMINISTRADOR'">
                    <v-icon
                      small
                      color="error"
                      @click="excluirUltimoItem(analise.id)"
                    >
                      mdi-delete
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-container v-if="analise.descricao == 'Renda' && !preMatricula.chamadaUtilizaCadunico" >
          <table-doc-renda-analise :preMatricula="preMatricula" >
          </table-doc-renda-analise>      
        </v-container>
        
      </v-card>
    </v-card>

    <v-card class="mb-3">
      <v-toolbar color="secondary" dark flat>
        <v-toolbar-title>Documentos</v-toolbar-title>
      </v-toolbar>
      <v-expansion-panels>
        <v-expansion-panel
          :disabled="!documento.arquivos.length"
          v-for="documento in preMatricula.documentos"
          :key="documento.id"
        >
          <v-expansion-panel-header>
            {{ documento.descricao }}
            <template v-slot:actions>
              <v-badge
                v-if="documento.arquivos.length"
                :content="documento.arquivos.length"
                color="primary"
                overlap
              >
              </v-badge>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list dense>
              <v-list-item
                v-for="arquivo in documento.arquivos"
                :key="arquivo.id"
                link
                @click="downloadArquivo(arquivo)"
              >
                <v-list-item-title>{{ arquivo.nome }}</v-list-item-title>
                <v-list-item-action>
                  <v-icon color="blue"> mdi-download </v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
    <v-card>
      <v-toolbar color="secondary" dark flat>
        <v-toolbar-title>Histórico de alterações</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-data-table
          dense
          hide-default-footer
          :headers="headersHistorico"
          :items="preMatricula.historico"
          disable-pagination
        >
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h9"
          >Você tem certeza que deseja excluir?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="orange lighten-3" @click="closeDelete">Fechar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="confirmarExclusaoUltimoItem">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialogo-parecer-recurso
      :tipo="tipoParecer"
      :analise="analiseAtual"
      :preMatricula="preMatricula"
      @salvou="salvouRascunho"
      @finalizou="finalizouParecer"
      :rascunho="rascunhoParecer"
      :mostrar="dlgParecer"
      @cancelar="dlgParecer = false"
    ></dialogo-parecer-recurso>

    <dialog-visualizar-item-prematricula
      @fechar="dlgVisualizarItem = !dlgVisualizarItem"
      :visivel="dlgVisualizarItem"
      :item="itemVisualizacao"
      mostrarArquivos
    ></dialog-visualizar-item-prematricula>
  </v-container>
</template>
<script>
import * as PreMatriculaService from "@/services/prematricula.service";
import * as ArquivoService from "@/services/arquivo.service";
import DadosBasicosCandidato from "@/components/DadosBasicosCandidato";
import DialogVisualizarItemPrematricula from "@/components/DialogVisualizarItemPrematricula";
import DialogoParecerRecurso from "@/components/DialogoParecerRecurso.vue";
import DocRendaAnalise from '@/components/DocRendaAnalise.vue';
import store from "@/store";

export default {
  name: "home",
  components: {
    "dados-basicos-candidato": DadosBasicosCandidato,
    "dialog-visualizar-item-prematricula": DialogVisualizarItemPrematricula,
    DialogoParecerRecurso,
    "table-doc-renda-analise":DocRendaAnalise,
  },
  props: {
    preMatricula: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dlgParecer: false,
      tipoParecer: null,
      tabCandidato: null,
      dlgVisualizarItem: false,
      dialogDelete: false,
      currentUser: store.getters.loggedUser,
      dlgAlterarStatusMatricula: false,
      idAnaliseItemExclusao: null,
      rascunhoParecer: {},
      itemVisualizacao: {},
      analiseAtual: null,
      headersAnalises: [
        {
          text: "Análise",
          align: "start",
          sortable: false,
          value: "descricao",
          width: "90%",
        },
        {
          text: "Status da Análise",
          align: "start",
          sortable: false,
          value: "status.descricao",
          width: "10%",
        },
        { text: "Parecer", value: "actions", sortable: false, align: "center" },
      ],
      headersArquivos: [
        {
          text: "Descricao",
          align: "start",
          sortable: false,
          value: "nome",
          width: "90%",
        },
        {
          text: "Download",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      headersHistorico: [
        {
          text: "Instante",
          align: "start",
          sortable: false,
          value: "instante",
        },
        {
          text: "Descrição",
          align: "start",
          sortable: false,
          value: "descricao",
        },
        {
          text: "Usuário",
          value: "usuario",
          sortable: false,
          align: "start",
        },
      ],
    };
  },
  computed: {
    tipoStatusPreMatricula() {
      let crole = this.currentUser.role;
      let lista = [];
      if (crole === "COMISSAO_DOCUMENTACAO" || crole === "ADMINISTRADOR") {
        lista.push({
          codigo: "CANDIDATO_MATRICULADO",
          descricao: "Candidato matriculado",
        });
        lista.push({
          codigo: "CANDIDATO_NAO_MATRICULADO",
          descricao: "Candidato não matriculado",
        });
      }

      if (crole === "ADMINISTRADOR") {
        lista.push({
          codigo: "DESISTENCIA_A_PEDIDO",
          descricao: "Desistência a pedido do estudante",
        });
        lista.push({
          codigo: "DESISTENCIA_DO_CANDIDATO",
          descricao: "Desistência a pedido do candidato",
        });
        lista.push({
          codigo: "ESTUDANTE_ELIMINADO",
          descricao: "Estudante eliminado por ato institucional",
        });
        lista.push({
          codigo: "MATRICULA_JUDICIAL",
          descricao: "Matrícula por determinação judicial",
        });
        lista.push({
          codigo: "ESTUDANTE_ELIMINADO_JUD",
          descricao: "Estudante eliminado por determinação judicial",
        });
        lista.push({
          codigo: "ANALISE_ENCERRADA",
          descricao: "Análise do curso encerrada",
        });
        
      }
      return lista;
    },
    getCorStatusMatricula() {
      //cores definidas em vuetify.js
      var codigo = this.preMatricula.status.codigo;
      var reg = this.preMatricula.statusRegistroMatricula.codigo;
      if (codigo == "APROVADA") {
        if (reg == "CANDIDATO_NAO_REGISTRADO")
          return { class: "warning", dark: false };
        if (reg == "CANDIDATO_MATRICULADO")
          return { class: "secondary", dark: true };
        if (reg == "MATRICULA_JUDICIAL")
          return { class: "secondary", dark: true };        
        if (reg == "CANDIDATO_NAO_MATRICULADO")
          return { class: "error", dark: true };
        if (reg == "DESISTENCIA_A_PEDIDO")
          return { class: "error", dark: true };
        if (reg == "ESTUDANTE_ELIMINADO") return { class: "error", dark: true };
        if (reg == "DESISTENCIA_DO_CANDIDATO")
          return { class: "error", dark: true };
        if (reg == "ANALISE_ENCERRADA")
          return { class: "error", dark: true };
        if (reg == "ESTUDANTE_ELIMINADO_JUD")
          return { class: "error", dark: true };
        
      }

      return { class: "secondary", dark: false };
    },
  },
  methods: {
    formatarReal(valor) {
      // Trata null, undefined, string vazia, NaN...
      if (valor == null || isNaN(Number(valor))) return "R$ 0,00";

      return Number(valor).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      });
    },
    podeEmitirParecer(analise) {
      return analise.permiteParecer || analise.permiteParecerDoRecurso;
    },
    emitirParecer(analise) {
      this.$nprogress.start();
      PreMatriculaService.getRascunhoAnalise(analise.id)
        .then((rascunho) => {
          this.rascunhoParecer = rascunho;
          this.analiseAtual = analise;
          this.dlgParecer = true;
          if (analise.permiteParecer) this.tipoParecer = "PARECER";
          if (analise.permiteParecerDoRecurso)
            this.tipoParecer = "PARECER-RECURSO";
        })
        .finally(() => this.$nprogress.done());
    },
    salvouRascunho() {
      this.dlgParecer = false;
      this.$emit("salvouRascunho");
    },
    finalizouParecer(candidatoAtualizado) {
      this.dlgParecer = false;
      this.$emit("finalizouParecer", candidatoAtualizado);
    },
    visualizarItem(item) {
      this.itemVisualizacao = item;
      this.dlgVisualizarItem = true;
    },

    alterarStatusRegistroMatricula() {
      this.dlgAlterarStatusMatricula = true;
    },
    fecharAlterarStatusRegistroMatricula() {
      this.dlgAlterarStatusMatricula = false;
    },
    salvarStatusRegistroPreMatricula() {
      this.$nprogress.start();
      PreMatriculaService.salvarStatusRegistroPreMatricula(
        this.preMatricula.id,
        this.preMatricula.statusRegistroMatricula.codigo,
      )
        .then((res) => {
          this.$msg.success("Status Salvo");
          this.fecharAlterarStatusRegistroMatricula();
          this.$emit("finalizouParecer", res.data);
        })
        .finally(() => {
          this.$nprogress.done();
        });
    },
    downloadArquivo(arquivo) {
      this.$nprogress.start();
      ArquivoService.getOne(arquivo.id)
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", arquivo.nome);
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .finally(() => {
          this.$nprogress.done();
        });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.idAnaliseItemExclusao = null;
    },
    excluirUltimoItem(idAnalise) {
      this.dialogDelete = true;
      this.idAnaliseItemExclusao = idAnalise;
    },
    confirmarExclusaoUltimoItem() {
      this.$nprogress.start();
      PreMatriculaService.excluirUltimoItem(this.idAnaliseItemExclusao)
        .then((res) => {
          this.$msg.success("Operação Salva");
          this.closeDelete();
          this.$emit("excluiuItem", res.data);
        })
        .finally(() => {
          this.$nprogress.done();
        });
    },
  },
};
</script>
